export const BREAKPOINT_SIZES = ['sm', 'md', 'lg'];
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 1260;
